module.exports = __webpack_public_path__ + "img/Financial-institutions.442c7464.png";